import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({ palette }: Theme) => ({
  actions: {
    display: 'flex',
    gap: '0.75rem',
    marginTop: '0.875rem',
  },
  asterisk: {
    position: 'relative',
    top: 2,
    right: 0,
    color: palette.error.main,
    fontSize: '1.5rem',
    lineHeight: 1,
  },
}));
